<template>
  <div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
      <Row type="flex" justify="center">
        <Col span="18">
          <FormItem label="物品" prop="goodsId">
            <Select v-model="formValidate.goodsId" placeholder="选择物品" @on-change="goodsChange">
              <Option v-for="g in goodsList" :key="g.id" :value="g.id">{{ g.name }}（积分{{ g.integralBranch }}，可兑换{{ g.saleQuantity }}）</Option>
            </Select>
          </FormItem>
          <FormItem label="物品名称">
            <Input class="widK" disabled v-model="formValidate.goodsName" />
          </FormItem>
          <FormItem label="积分单价">
            <Input class="widK" disabled v-model="formValidate.integralBranch" />
          </FormItem>
          <FormItem label="兑换人姓名" prop="name">
            <Input class="widK" v-model.trim="formValidate.name" placeholder="姓名" />
          </FormItem>
          <FormItem label="身份证号码" prop="idCard">
            <Input class="widK" v-model.trim="formValidate.idCard" placeholder="身份证号码" />
          </FormItem>
          <FormItem label="兑换数量" prop="exchangeCount">
            <Input class="widK" v-model.trim="formValidate.exchangeCount" placeholder="数量" @on-change="calcTotal" />
          </FormItem>
          <FormItem label="消耗积分">
            <Input class="widK" disabled v-model="formValidate.totalBranch" />
          </FormItem>
          <FormItem label="兑换时间" prop="exchangeTime">
            <DatePicker class="widK" type="datetime" v-model="formValidate.exchangeTime" placeholder="选择时间" format="yyyy-MM-dd HH:mm:ss" @on-change="v=>formValidate.exchangeTime=v"></DatePicker>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Button type="primary" v-if="display" @click="submit()">确定</Button>
        <Button type="default" v-if="display" style="margin:0 16px" @click="handleReset">重置</Button>
        <Button type="default" @click="back">返回</Button>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  name: "integralExchangeRecordAdd",
  data() {
    return {
      display: true, goodsList: [],
      formValidate: { goodsId: "", goodsName: "", integralBranch: 0, name: "", idCard: "", exchangeCount: "", totalBranch: 0, exchangeTime: "" },
      ruleValidate: {
        goodsId: [{ required: true, message: "请选择物品", trigger: "change" }],
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        idCard: [{ required: true, message: "请填写身份证号码", trigger: "blur" }],
        exchangeCount: [{ required: true, message: "请填写数量", trigger: "blur" }],
        exchangeTime: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
    };
  },
  created() { this.loadGoods(); },
  methods: {
    loadGoods() {
      this.$http.get("/api/tIntegralGoods/page", { params: { pageSize: 999 } }).then(r => {
        if (r.data.code == 200) this.goodsList = r.data.data.list || [];
      });
    },
    goodsChange(val) {
      let g = this.goodsList.find(x => x.id == val);
      if (g) { this.formValidate.goodsName = g.name; this.formValidate.integralBranch = g.integralBranch; }
      this.calcTotal();
    },
    calcTotal() {
      let count = parseInt(this.formValidate.exchangeCount) || 0;
      let price = parseInt(this.formValidate.integralBranch) || 0;
      this.formValidate.totalBranch = count * price;
    },
    submit() {
      this.$refs.formValidate.validate(v => {
        if (!v) return;
        let p = JSON.parse(JSON.stringify(this.formValidate));
        this.$http.post("/api/tIntegralExchangeRecord/save", p).then(r => {
          if (r.data.code == 200) { this.$Message.success("提交成功"); this.back(); }
        });
      });
    },
    handleReset() { this.$refs.formValidate.resetFields(); },
    back() {
      this.$store.commit("app/closePage", { vm: this, fromName: this.$route.name, toName: "integralExchangeRecord" });
    },
  },
};
</script>
<style scoped>#content { width: 100%; } .disabled { pointer-events: none; }</style>
